// extracted by mini-css-extract-plugin
export default {"wrapper":"footer-item_wrapper__9hAQW","boxContent":"footer-item_boxContent__3NM7z"};